import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { AccordionStyle } from './styles';
import { Button } from '../Buttons/Button';

interface AccordionProps {
  children: React.ReactNode;
  childrenHeader?: React.ReactNode;
  title: React.ReactNode;
  icon?: boolean;
  className?: string;
  activeButton?: boolean;
  defaultOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  onCallback?: () => void;
}

export const AccordionExpanded: React.FC<AccordionProps> = ({
  children,
  title,
  icon,
  childrenHeader,
  defaultOpen = false,
  className,
  activeButton,
  onOpen,
  onClose,
  onCallback,
}) => {
  const [openAccordion, setOpenAccordion] = useState(defaultOpen);

  const handleToggleAccordion = () => {
    const toggle = !openAccordion;
    setOpenAccordion(toggle);
    (toggle ? onOpen : onClose)?.();
  };

  return (
    <AccordionStyle className={className}>
      <div className="divHeader">
        <button type="button" className="accordionTitle" onClick={handleToggleAccordion}>
          <p>{title}</p>
        </button>
        <div className="optionalIcons">
          {childrenHeader}
          <button
            className={icon ? 'buttonExpandMore' : 'divNone'}
            type="button"
            onClick={handleToggleAccordion}>
            {openAccordion ? (
              <ExpandLessIcon fontSize="large" />
            ) : (
              <ExpandMoreIcon fontSize="large" />
            )}
          </button>
        </div>
      </div>

      {openAccordion && (
        <div className="content">
          {activeButton && (
            <div className="containerButton">
              <Button
                text="Marcar/Desmarcar todos"
                background="transparent"
                color="primary"
                textHoverColor="tertiary_500"
                dimensions={{ width: '13rem', height: '1.5rem' }}
                font={{ size: 16, weight: 500 }}
                onClick={onCallback}
              />
            </div>
          )}
          {children}
        </div>
      )}
    </AccordionStyle>
  );
};
